(function () {
    'use strict';

    window.$ = window.jQuery = require('jquery');
    window.moment = require('moment');
    require('bootstrap');
    require('selectize');
    require('./modules/Localization');
    require('./modules/Notification');

    var Loader = require('./loader');

    Loader.load();
    $('#menu-toggle').click((e) => {
        let element = $('#header-menu');
        element.toggleClass('open');
        e.target.src = element.hasClass('open') ? e.target.dataset.onSrc : e.target.dataset.offSrc;
    });
    $('.back-to-top').on('click', function (e) {
        e.preventDefault();

        $('body, html').stop().animate(
            {
                scrollTop: 0,
            },
            500,
            'swing'
        );
    });
    $('body').on('click', '.taxes-toggle', function () {
        $('ul.taxes').toggleClass('open');
        $('.taxes-container').toggleClass('open');
    });
    $(document).ready(function () {
        $('button.quote-engine').removeAttr('disabled');
        $('.sidebar-panel.search form button').removeAttr('disabled');
    });

    $('.gm-logout-button').on('click', function (e) {
        e.preventDefault();

        localStorage.removeItem('HTTP');
        localStorage.removeItem('frontend-booking');

        window.location = $(this).attr('data-route');
    });
})();

import Vue from 'vue';

import DobPicker from './apps/shared/components/ui/DobPicker.vue';
Vue.component('DobPicker', require('./apps/shared/components/ui/DobPicker.vue').default);

var app = new Vue({
    el: '#dob-group',
    components: {
        DobPicker: require('./apps/shared/components/ui/DobPicker.vue').default,
    },
});
